<template>
	<div class="item-teach">
		<div class="teach-con"  :style="{minHeight:fullpage+'px'}">
			<div class="teach-head">
 				<div class="con-list" :class="index==num?'color':''" :style="{'width':100/headList.length+'%'}" v-for="(i,index) in headList" @click="openList(i.cate_id,index)" :key='index'>
					<div :style="{'border-left': index==0?'none':''}">
						<img :src="i.icon" height="38" width="32" alt="">
						<p>{{i.cate_name}}</p>
					</div>
				</div>
			</div>
			<div class="teach-list">
				<p style="text-align:center;margin-top:20px;" v-show="list.length==0">内容更新中，敬请期待</p>
				<div class="item" v-for="(i,index) in list" :key='index'>
					<div class="fl">
						{{i.file_name}}
					</div>
					<div class="fr" @click="showPDF(i.file_path)">
						<a href="javascript:;"></a>
					</div>
				</div>
			</div>
		</div>
		<div class="teach-model" v-show="models" @click="models=false">
		 	<img src="../../assets/teach-bg.png" height="100%" width="100%" alt="">
		</div>
	   	<p class="pdfClose" v-show="ifpdf"><button @click="ifpdf=false">关闭</button><button @click="renderPage(scale+0.5)">看不清？点这试试</button><button @click="renderPage(scale-0.5)">缩小</button></p>
	   	<div id="container" v-show="ifpdf" ref="wrap">
	 	</div>
		
	</div>
</template>
<script>
import foot from "../../components/footer.vue"
import icon1 from "../../assets/teach-1.png"
import icon2 from "../../assets/teach-2.png"
import icon3 from "../../assets/teach-3.png"
import icon4 from "../../assets/teach-4.png"
import { Indicator } from 'mint-ui';
import { Toast } from 'mint-ui';
// import PDFJS from 'pdfjs-dist';

export default{
	data(){
		return {
			headList:[],  //顶部列表
			num:0,
			list:[],
			isshowpdf:true,
			page:1,
			url:"",
			models:false,
			pdfDoc: null,
			pageNum: 1,
			pageRendering: false,
			pageNumPending: null,
			scale: 0.5,
			ifpdf:false,
			fullpage:document.documentElement.clientHeight
		}
	},
	components:{
		foot:foot,
	},
	computed:{
		cate(){
			return this.$route.query.cateid
		},
		type(){
			return this.$store.state.type
		}
	},
	mounted(){
		this.$store.state.num=6;
		this.sj(this.cate);
	},
	methods:{
		//
		//pdf切换事件
		//
		showPDF (url) {
			window.open(url);
			return false;
		//
		//以下代码为原pdf预览代码
		//
		var u = navigator.userAgent;
		var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
		var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
		if(isiOS){
			window.open(url);
			return false;
		}
	    Indicator.open({text: '解析中...',spinnerType: 'fading-circle'});
	    let _this = this
	      PDFJS.getDocument(url).then(function (pdf) {
	        _this.pdfDoc = pdf
	        _this.renderPage(_this.scale)
	      })
	      //
	      //点击时清空canvas
	      //
	      this.ifpdf=true;
	    },
	    //
	    //pdf读取渲染事件,num为所传的页码
	    //
	    renderPage (scale) {
	      this.pageRendering = true
	      let _this = this
	      let index=this.pdfDoc.numPages;   //this.pdfDoc.numPages为总共的页码
	      //
	      //循环读取所有pdf页面的数据，绘制成canvas添加到#container的盒子中
	      //
	      _this.scale=scale;
	      _this.$refs.wrap.innerHTML="";
	      for(var i=0;i<index;i++){
		      this.pdfDoc.getPage(i+1).then(function (page) {
		      	// console.log(page)
		        var viewport = page.getViewport(_this.scale)
		        let canvas = document.createElement('canvas');
		        canvas.height = viewport.height
		        canvas.width = viewport.width
		        // Render PDF page into canvas context
		        var renderContext = {
		          canvasContext: canvas.getContext('2d'),
		          viewport: viewport
		        }
		        var renderTask = page.render(renderContext)
		        // Wait for rendering to finish
		        renderTask.promise.then(function () {
		          _this.pageRendering = false
		          if (_this.pageNumPending !== null) {
		            // New page rendering is pending
		            this.renderPage(_this.pageNumPending)
		            _this.pageNumPending = null
		          }
		        })
		        _this.$refs.wrap.appendChild(canvas);
		      })
	      	}
	      	Indicator.close();
	      	Toast("解析完毕，上滑下滑即可查看");
	    },
	    queueRenderPage (num) {
	      if (this.pageRendering) {
	        this.pageNumPending = num
	      } else {
	        this.renderPage(num)
	      }
	    },
	    //
	    //上一页事件
	    //
	    onPrevPage () {
	      if (this.pageNum <= 1) {
	        return
	      }
	      this.pageNum--
	      this.queueRenderPage(this.pageNum)
	    },
	    //
	    //下一页事件
	    //
	    onNextPage () {
	      if (this.pageNum >= this.pdfDoc.numPages) {
	        return
	      }
	      this.pageNum++
	      this.queueRenderPage(this.pageNum)
	    },
		//
		//首次进入页面获取pdf列表
		//
		sj(cate){ 
      Indicator.open({text: '加载中...',spinnerType: 'fading-circle'});
			this.$axios.get("netusers/pdfcate",{params:{type:this.type,cate_id:cate}}).then(succ=>{
				this.headList=succ.data.data.data;
				this.headList[0].icon=icon1;
				this.headList[1].icon=icon2;
				this.headList[2].icon=icon3;
				this.headList[3].icon=icon4;
				Indicator.close();
				this.openList(this.headList[0].cate_id,0);
				console.log(this.headList)
			}).catch(error=>{
				Indicator.close();
			})
		},
		//
		//点击顶部列表，请求不同的pdf列表
		//
		openList(id,index){
			this.num=index;
			this.$axios.get("netusers/pdflist",{params:{cate_id:id}}).then(succ=>{
        if(succ.data.data.state=="200000"){
    			this.list=[];
					this.list=succ.data.data.data;
				}else{
					Toast(succ.data.data.message)
						Indicator.close();
				}
			}).catch(error=>{
				Toast(error)
        Indicator.close();
			})
		},
	}
}
</script>
<style scoped lang="scss">
#container {
  background-color: rgba(0,0,0,0.75);
  position:fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;  bottom: 100px;right: 0;
  text-align: center;
  padding: 0px;
  overflow: auto;
  box-sizing:border-box;padding:50px 0 0 0;
}

canvas{
	/*width: 100%;*/
	/*height: 90%;*/
}

.pdf-page {
}

.foot {
  position: fixed;
  transform: translate(-50%,0);
  left: 50%;  top: 30px;
}

.pdfClose{
	button:nth-child(1){
		position: absolute;right:10px;top:10px;padding:10px;background:#50a7f8;border:0;color:#FFF;border-radius: 6px;z-index: 99999999;
	}
	button:nth-child(2){
		position: absolute;right:20%;top:10px;padding:10px;background:#50a7f8;border:0;color:#FFF;border-radius: 6px;z-index: 99999999;
	}
	button:nth-child(3){
		position: absolute;right:60%;top:10px;padding:10px;background:#50a7f8;border:0;color:#FFF;border-radius: 6px;z-index: 99999999;
	}
}
#container{
	font-family:"微软雅黑",Arial, Helvetica, sans-serif;
}
</style>








// WEBPACK FOOTER //
// src/mobile/tation/TrainingPDF.vue